import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalService } from "src/app/services/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  submitted = false;
  passwordFormNew: FormGroup;
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.ls.get("createdBy");
  changepassword: any;
  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    public fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.passwordFormNew = this.fb.group(
      {
        user_id: this.ls.get("createdBy"),
        old_password: ["", Validators.required],
        new_password: ["", Validators.required],
        confirm_new_password: ["", Validators.required],
      },
      { validators: this.checkPassword }
    );
  }

  checkPassword(form: FormGroup) {
    if (form.value.new_password == form.value.confirm_new_password) {
      return null;
    }
    form.controls.confirm_new_password.setErrors({ notSame: true });
    return { notSame: true };
  }

  get f() {
    return this.passwordFormNew.controls;
  }
  async changePassword(form: FormGroup) {
    this.submitted = true;
    if (this.passwordFormNew.invalid) {
      return;
    }
    this.spinner.show();
    let requestData = {
      user_id: this.ls.get("createdBy"),
      old_password: form.value.old_password,
      new_password: form.value.new_password,
    };
    this.changepassword = await this.globalService.create(
      "user/change-password",
      requestData
    );
    this.passwordFormNew.reset();
    this.submitted = false;
    if (this.changepassword["status"] === 200) {
      Swal.fire("Success!", this.changepassword["message"], "success");
    } else if (this.changepassword["status"] === 400) {
      Swal.fire("Error!", this.changepassword["error"].message, "error");
    }
    this.spinner.hide();
  }
}
